<script lang="ts">
    import {getSanitize} from 'src/core';
    import {marked} from 'marked';

    export let markdown = '';
    export let block = false;

    const sanitize = getSanitize();

    $: htmlContent = block
        ? marked.parse(markdown, {async: false})
        : marked.parseInline(markdown, {async: false});
</script>

{@html sanitize(htmlContent)}